import { accounts as actionTypes } from '$constants/action-types';

export const create = params => ({   
  type: actionTypes.CREATE,   
  params    
});   
    
export const createRequest = () => ({   
  type: actionTypes.CREATE_REQUEST    
});   
    
export const createSuccess = result => ({   
  type: actionTypes.CREATE_SUCCESS,   
  result    
});   
    
export const createFailure = errors => ({   
  type: actionTypes.CREATE_FAILURE,   
  errors    
});

export const login = params => ({
  type: actionTypes.LOGIN,
  params
});

export const loginRequest = () => ({
  type: actionTypes.LOGIN_REQUEST
});

export const loginSuccess = result => ({
  type: actionTypes.LOGIN_SUCCESS,
  result
});

export const loginFailure = errors => ({
  type: actionTypes.LOGIN_FAILURE,
  errors
});

export const recover = params => ({
  type: actionTypes.RECOVER,
  params
});

export const recoverSuccess = result => ({
  type: actionTypes.RECOVER_SUCCESS,
  result
});

export const recoverFailure = errors => ({
  type: actionTypes.RECOVER_FAILURE,
  errors
});

export const resetPassword = params => ({
  type: actionTypes.RESET_PASSWORD,
  params
});

export const resetPasswordSuccess = result => ({
  type: actionTypes.RESET_PASSWORD_SUCCESS,
  result
});

export const resetPasswordFailure = errors => ({
  type: actionTypes.RESET_PASSWORD_FAILURE,
  errors
});

export const logout = () => ({
  type: actionTypes.LOGOUT
});

export const fetchCurrent = () => ({
  type: actionTypes.FETCH_CURRENT
});

export const fetchCurrentRequest = () => ({
  type: actionTypes.FETCH_CURRENT_REQUEST
});

export const fetchCurrentSuccess = result => ({
  type: actionTypes.FETCH_CURRENT_SUCCESS,
  result
});



// WEBPACK FOOTER //
// ./src/actions/accounts.js